/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeoJsonCountyDataModelApiModel } from '../../models/geo-json-county-data-model-api-model';

export interface GetBoundriesByState$Params {
  stateId: string;
}

export function getBoundriesByState(http: HttpClient, rootUrl: string, params: GetBoundriesByState$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeoJsonCountyDataModelApiModel>>> {
  const rb = new RequestBuilder(rootUrl, getBoundriesByState.PATH, 'get');
  if (params) {
    rb.path('stateId', params.stateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeoJsonCountyDataModelApiModel>>;
    })
  );
}

getBoundriesByState.PATH = '/v1/counties/boundries/{stateId}';
